var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDersatamalari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 179,
    viewBox: "0 0 212 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5855 170.84C32.3637 170.84 30.5098 172.684 30.5098 174.927C30.5098 177.156 32.349 179.015 34.5855 179.015C36.822 179.015 38.6612 177.171 38.6612 174.927C38.6612 172.684 36.822 170.84 34.5855 170.84Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.116 12.2481C149.485 12.2481 152.222 9.50338 152.222 6.12407C152.222 2.74477 149.485 0 146.116 0C142.747 0 140.01 2.74477 140.01 6.12407C140.01 9.50338 142.747 12.2481 146.116 12.2481Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.793 17.5454C120.014 17.5454 121.868 15.7008 121.868 13.4578C121.868 11.2147 120.029 9.37012 117.793 9.37012C115.571 9.37012 113.717 11.2147 113.717 13.4578C113.717 15.7008 115.571 17.5454 117.793 17.5454Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.206 93.6319C208.575 93.6319 211.312 90.8872 211.312 87.5079C211.312 84.1286 208.575 81.3838 205.206 81.3838C201.836 81.3838 199.1 84.1286 199.1 87.5079C199.1 90.8872 201.836 93.6319 205.206 93.6319Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.892 107.65C198.217 107.65 199.291 108.728 199.291 110.056C199.291 111.384 198.217 112.461 196.892 112.461C195.568 112.461 194.494 111.384 194.494 110.056C194.494 108.728 195.568 107.65 196.892 107.65Z",
    fill: "#F99E1D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.16 41.9705C190.16 35.3688 184.791 30 178.189 30H11.9784C5.37677 30 0 35.3688 0 41.9705C0 41.9705 0 60.6142 0 60.6222C0 60.6222 0.174984 61.1312 0.445413 61.8232V153.03C0.445413 159.631 5.81423 165 12.4159 165H178.181C184.783 165 190.152 159.631 190.152 153.03V60.6142V60.6063V41.9705H190.16ZM6.0608 57.5759V41.9705C6.0608 38.7094 8.71737 36.0608 11.9784 36.0608H178.189C181.45 36.0608 184.099 38.7094 184.099 41.9705V57.5759H6.51417H6.0608Z",
    fill: "#3733BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 45.1441C11.2227 46.0667 11.9783 46.8223 12.9009 46.8223H25.9452C26.8678 46.8223 27.6234 46.0667 27.6234 45.1441C27.6234 44.2135 26.8678 43.4658 25.9452 43.4658H12.9009C11.9783 43.4658 11.2227 44.2135 11.2227 45.1441Z",
    fill: "#F99E1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.948 46.8145H178.992C179.915 46.8145 180.67 46.0589 180.67 45.1363C180.67 44.2057 179.923 43.458 178.992 43.458H165.948C165.025 43.458 164.27 44.2057 164.27 45.1363C164.277 46.0669 165.025 46.8145 165.948 46.8145Z",
    fill: "#F99E1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3214 99.2461V99.3018H113.398C114.345 99.3018 115.108 98.6257 115.108 97.7826V72.9508C115.108 72.1157 114.345 71.4316 113.398 71.4316H76.755C75.8085 71.4316 75.0449 72.1077 75.0449 72.9508V97.7826C75.0449 98.6257 75.8085 99.3018 76.755 99.3018H93.8398V99.2461H96.3214Z",
    fill: "#F99E1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3152 149.633V124.794C68.3152 123.958 67.5516 123.274 66.6051 123.274H29.9619C29.0233 123.274 28.2598 123.95 28.2598 124.794V149.633C28.2598 150.468 29.0233 151.153 29.9619 151.153H66.613C67.5516 151.153 68.3152 150.468 68.3152 149.633Z",
    fill: "#F99E1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.755 123.282C75.8164 123.282 75.0449 123.958 75.0449 124.801V149.641C75.0449 150.476 75.8085 151.16 76.755 151.16H113.406C114.345 151.16 115.116 150.484 115.116 149.641V124.801C115.116 123.966 114.353 123.282 113.406 123.282H76.755Z",
    fill: "#F99E1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.546 123.282C122.607 123.282 121.844 123.958 121.844 124.801V149.641C121.844 150.476 122.607 151.16 123.546 151.16H160.197C161.136 151.16 161.899 150.484 161.899 149.641V124.801C161.899 123.966 161.136 123.282 160.197 123.282H123.546Z",
    fill: "#F99E1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2812 121.168H51.7708V112.896H93.8385V121.168H96.3201V112.896H138.388V121.168H140.877V110.685H96.3201V99.3027V99.2471H93.8385V99.3027V110.685H49.2812V121.168Z",
    fill: "#F99E1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 179,
    fill: "white",
    transform: "translate(18.3125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDersatamalari);
export default __webpack_public_path__ + "static/media/dersatamalari.cc4e3f88bc9af24ba9f52ee10faa318d.svg";
export { ForwardRef as ReactComponent };